// ─── Plans : NOM, PRIX et LIMITES lus en base (Core) ──────────────
// Repris de MoPCal (`config/plans`) : le nom d'un forfait n'est PAS une
// constante — l'administration le renomme, change les prix et les limites sans
// livrer de version. Les valeurs ci-dessous ne sont qu'un REPLI (et la graine
// du document).
//
// Répartition des documents, comme MoPCal :
//   config/plans           → nom, ordre, prix, limites d'usage
//   config/fonctionnalites → paliers inclus + jetons d'éléments gérables
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// `null` = illimité (Firestore ne stocke pas Infinity).
export const PLANS_DEFAUT = {
  gratuit: {
    id: 'gratuit', label: 'Gratuit', ordre: 0,
    piecesJointes: 1, demandesParMois: 10, historiqueDays: 30,
    pubFixe: true, pubEvenement: true, exportPdf: false, syncCalendrier: false,
  },
  famille: {
    id: 'famille', label: 'Basic', ordre: 1, prix: { mensuel: 1.99 },
    piecesJointes: 5, demandesParMois: null, historiqueDays: 365,
    pubFixe: true, pubEvenement: false, exportPdf: true, syncCalendrier: false,
  },
  basicplus: {
    id: 'basicplus', label: 'Basic +', ordre: 2, prix: { mensuel: 4.99 },
    piecesJointes: 10, demandesParMois: null, historiqueDays: null,
    pubFixe: false, pubEvenement: false, exportPdf: true, syncCalendrier: false,
  },
  familleplus: {
    id: 'familleplus', label: 'Full', ordre: 3, prix: { mensuel: 9.99 },
    piecesJointes: null, demandesParMois: null, historiqueDays: null,
    pubFixe: false, pubEvenement: false, exportPdf: true, syncCalendrier: true,
  },
  // Attribué par l'administration seulement (cf. plans.js) — pas de prix : ce
  // n'est pas à vendre. `ordre` volontairement élevé, hors de l'échelle
  // commerciale plutôt qu'« au-dessus » du forfait le plus cher.
  horscat: {
    id: 'horscat', label: 'Hors catégorie', ordre: 99,
    piecesJointes: null, demandesParMois: null, historiqueDays: null,
    pubFixe: false, pubEvenement: false, exportPdf: true, syncCalendrier: true,
  },
};

export const estIllimite = (v) => v == null || v === Infinity;
export const libelleLimite = (v, motIllimite = '∞') => (estIllimite(v) ? motIllimite : String(v));

// Écoute `config/plans` en fusionnant avec les valeurs de repli, plan par plan :
// un document partiel (l'admin n'a renseigné qu'un prix) reste exploitable.
export function ecouterPlans(callback, onErreur) {
  return onSnapshot(doc(db, 'config', 'plans'),
    (snap) => {
      const d = snap.exists() ? snap.data() : {};
      const out = {};
      for (const id of Object.keys(PLANS_DEFAUT)) out[id] = { ...PLANS_DEFAUT[id], ...(d[id] || {}) };
      // Un plan créé depuis l'administration et inconnu du code doit apparaître.
      for (const id of Object.keys(d)) if (!out[id] && d[id]?.label) out[id] = { id, ...d[id] };
      callback(out);
    },
    (e) => { callback({ ...PLANS_DEFAUT }); onErreur?.(e); });
}

// Nom affiché : base → repli → identifiant brut.
export const nomPlan = (plans, id) => plans?.[id]?.label || PLANS_DEFAUT[id]?.label || id || '';
